var map = {
	"./shuoming-1@2x.png": 32817,
	"./shuoming-2@2x.png": 36654,
	"./shuoming-3@2x.png": 56038,
	"./shuoming-4@2x.png": 80645,
	"./shuoming-5@2x.png": 89263,
	"./shuoming-6@2x.png": 2769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67125;